
import { Options, Vue } from 'vue-class-component'

import MessageText from './MessageText.vue'
import { clamp } from '@/util/math'

@Options({
    name: 'MessageWindow',
    props: {
        zIndex: { required: true },
    },
    data: function (): any {
        return {
            transformations: {
                clientX: 0,
                clientY: 0,
                movementX: 0,
                movementY: 0,
                zoom: 1,
            },
        }
    },
    components: { MessageText },
    mounted: function () {
        this.setDraggablePosition(
            0.4 * window.innerWidth * Math.random(),
            0.4 * window.innerHeight * Math.random(),
        )
    },
    methods: {
        windowBarDrag: function (event: MouseEvent) {
            this.transformations.clientX = event.clientX
            this.transformations.clientY = event.clientY
            document.onmousemove = (event: MouseEvent) => {
                event.preventDefault()
                this.setDraggablePosition(event.clientX, event.clientY)
            }
            document.onmouseup = () => {
                document.onmouseup = null
                document.onmousemove = null
            }
        },
        windowScaleDrag: function (event: MouseEvent) {
            this.transformations.clientX = event.clientX
            this.transformations.clientY = event.clientY
            document.onmousemove = (event: MouseEvent) => {
                event.preventDefault()
                this.setScale(event.clientX, event.clientY)
            }
            document.onmouseup = () => {
                document.onmouseup = null
                document.onmousemove = null
            }
        },
        setDraggablePosition: function (x: number, y: number) {
            this.transformations.movementX =
                x <= 0 || x >= innerWidth ? 0 : this.transformations.clientX - x
            this.transformations.movementY =
                y <= 0 || y >= innerHeight
                    ? 0
                    : this.transformations.clientY - y
            this.transformations.clientX = x
            this.transformations.clientY = y

            this.$refs.draggable.style.top =
                this.$refs.draggable.offsetTop -
                this.transformations.movementY +
                'px'
            this.$refs.draggable.style.left =
                this.$refs.draggable.offsetLeft -
                this.transformations.movementX +
                'px'
        },
        setScale: function (x: number, y: number) {
            this.transformations.movementX = this.transformations.clientX - x
            this.transformations.movementY = this.transformations.clientY - y
            this.transformations.clientX = x
            this.transformations.clientY = y

            this.transformations.zoom = clamp(
                this.transformations.zoom +
                    0.01 * -Math.sign(this.transformations.movementX),
                0.75,
                1.5,
            )
            this.$refs.draggable.style.zoom = this.transformations.zoom
        },
    },
})
export default class MessageWindow extends Vue {}
